export interface ExchangeRate {
  baseCurrency: string
  quoteCurrency: string
  dateTime: string
  rate: number
  markup: number
  originalRate: number
  withdrawalRate: number
}

export enum ExchangeRateKey {
  baseCurrency = 'baseCurrency',
  quoteCurrency = 'quoteCurrency',
  dateTime = 'dateTime',
  rate = 'rate',
  markup = 'markup',
  originalRate = 'originalRate',
  withdrawalRate = 'withdrawalRate',
  newDepositRate = 'newDepositRate',
  newWithdrawalRate = 'newWithdrawalRate',
}
